/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import tentacle from '@/store/modules/tentacles.js';
import customer from '@/store/modules/customers.js';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		tentacle,
		customer
	},
});
